export const enumLanguages = {
  pt: "pt-br",
  en: "en",
};
